module.exports = __webpack_public_path__ + "static/img/40012 (5).d04d822.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40012 (5).webp
// module id = dwu0
// module chunks = 14